const messages = {
  message: {
    name: 'Name',
    surName: 'Surname',
    mobile: 'Mobile number',
    email: 'Email',
    company: 'Business name',
    cif: 'SSN / ID TAX',
    profile: 'Customer Profile',
    phone: 'Phone number',
    country: 'Country',
    location: 'Region',
    address: 'Address',
    city: 'City',
    cp: 'Zip code',
    web: 'Website',
    comment: 'Observations',
    terms: {
      wp: 'I have read and I accept the <a href="/politica-privacidad">privacy policy</a> and the <a href="http://myzone.airzone.es/terms-use">term of use</a>.',
      myzone: 'I have read and I accept the <a href="/privacy-policy">privacy policy</a> and the <a href="/terms-use">term of use</a>.',
    },
    infoComercial: 'I want to receive information about Airzone news',
    formsError: {
      terms: 'You must accept the terms and conditions.',
      front: 'Unable to send the form due to the following errors.',
      server: 'Unable to send, please try again later.',
    },
    formsSuccess: {
      AirzoneSIM: 'You have registered correctly, you will soon receive a mail with the tool.',
      Myzone: 'Your request has been registered, it will be processed as soon as possible.',
    },
    personalData: 'Your personal data',
    companyData: 'Your company data',
    submit: 'Submit',
    selectSim: {
      label: '¿Como conoció Airzone SIM?',
      options: {
        'Técnico/Comercial/Prescriptor': 'Técnico / Comercial / Prescriptor',
        'Distribuidor/Oficial/ATD': 'Distribuidor / Oficial / ATD',
        'Promotora/Constructora': 'Promotora / Constructora',
        'Arquitecto/Ingeniería': 'Arquitecto / Ingeniería',
        Instalador: 'Instalador',
        'RRSS/Medios': 'Redes sociales / Medios',
        'Cursos-Formacion': 'Cursos de Formación',
      },
    },
  },
};

export default messages;
